module.exports = __webpack_public_path__ + "static/media/2.082ff7d9.jpg";